import { styled } from 'goober';
export var FlexRow = styled('div')(function () {
    return {
        display: 'flex',
        flexDirection: 'row',
    };
});
export var FlexRowRight = styled(FlexRow)(function () {
    return {
        justifyContent: 'flex-end',
    };
});
export var FlexCol = styled('div')(function (_a) {
    var _b = _a.$flexGrow, $flexGrow = _b === void 0 ? false : _b, _c = _a.$maxHeight, $maxHeight = _c === void 0 ? 'none' : _c;
    return {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: $flexGrow ? 1 : 0,
        maxHeight: $maxHeight,
    };
});
export var FlexColItemRight = styled(FlexCol)(function (_a) {
    var $flex = _a.$flex;
    return {
        flex: $flex,
        marginLeft: '15px',
    };
});
export var FlexColItemLeft = styled(FlexCol)(function (_a) {
    var $flex = _a.$flex;
    return {
        flex: $flex,
        marginRight: '15px',
    };
});
export var FlexColRight = styled(FlexCol)(function () {
    return {
        justifyContent: 'flex-start',
    };
});
